import {SlickWrapper} from 'epic-react-common';
import PropTypes from 'prop-types';
import React from 'react';

import StandingItem from './StandingItem';

export default class SkirmishStandings extends React.Component {
  static propTypes = {
    data: PropTypes.object,
  };
  render() {
    const {data} = this.props;
    const {weekStandings} = data;
    const standings = [];
    if (weekStandings && weekStandings.length) {
      for (let x = 0; x < weekStandings.length; x++) {
        standings.push(<StandingItem key={`standing-${x}`} standing={weekStandings[x]} />);
      }
    }
    const sliderOptions = {
      infinite: true,
      speed: 700,
      draggable: true,
      touchMove: true,
      focusOnSelect: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      dots: false,
    };
    return (
      <div className="skirmish-standings">
        <SlickWrapper
          ref={(c) => {
            this.standingsSlider = c;
          }}
          options={sliderOptions}>
          {standings}
        </SlickWrapper>
      </div>
    );
  }
}
